import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/home/main.png'
import _imports_1 from '@/assets/img/home/vs.svg'
import _imports_2 from '@/assets/img/home/notice.png'


const _withScopeId = n => (_pushScopeId("data-v-00b76e68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "visual" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "メインビジュアル",
    id: "mainVisual"
  })
], -1))
const _hoisted_3 = { id: "cont" }
const _hoisted_4 = { id: "box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "entry",
  src: _imports_1,
  alt: "今週のバトルをみる"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  id: "notice",
  src: _imports_2,
  alt: "notice"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createVNode(_component_router_link, {
          to: {path:_ctx.nextPage()}
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["to"]), [
          [_vShow, _ctx.isLoggedIn || !_ctx.isInClient]
        ]),
        _hoisted_6
      ])
    ])
  ]))
}